import "./Overview.scss";
import StatCard from "../StatCard/StatCard";

const Overview = ({
  subscribers,
  description,
  subredditPulse,
  searchTerm,
  sr = false,
}) => {
  const data = {
    one: {
      info: sr
        ? `r/${searchTerm}`
        : searchTerm[0].toUpperCase() + searchTerm.slice(1),
      title: sr ? "Subreddit" : "Keyword",
    },
    two: {
      info: subscribers,
      title: sr ? "Subscribers" : "Avg. Number of Comments By Post",
    },
    three: {
      info: subredditPulse,
      title: sr ? "Activity Status" : "Median Number of Comments By Post",
    },
    four: {
      info: description,
      title: "Description",
    },
  };

  return (
    <section className="overview">
      <div className="overview__title-container">
        <h2 className="overview__title">Overview</h2>
      </div>
      <div className="overview__stats">
        <StatCard info={data.one.info} title={data.one.title} type="name" />
        <StatCard
          info={data.two.info}
          title={data.two.title}
          type="subscribers"
        />
        <StatCard
          info={data.three.info}
          title={data.three.title}
          type="subredditPulse"
        />
      </div>
      <StatCard
        info={data.four.info}
        title={data.four.title}
        type="description"
      />
    </section>
  );
};

export default Overview;
